import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TransferState } from "@angular/platform-browser";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class OkrConvergenceService {
  constructor(
    private readonly http: HttpClient,
    private readonly transferState: TransferState
  ) { }

  projectList() {
    return this.http.get("delivery/project-list?flag=mapped_list");
  }

  getKeyResultsRecords(query?: any) {
    return this.http.get(`dynamic-form/?form_name=${query}` + `&flag=master`);
  }

  getFrequencyValues() {
    return this.http.get(`dynamic-form/kr_measure_of_success_frequency`);
  }
  getUnitValues() {
    return this.http.get(`dynamic-form/kr_measure_of_success_unit`);
  }

  getGoalMaster(queryparam: any) {
    return this.http.get(`okr/hierarchy/?${queryparam}`);
  }

  getWhatIfMetricsValues(qParam: string): Observable<any> {
    return this.http.get(`okr/project-goals/project-metrics-values/?${qParam}`);
  }

  getMosMaster() {
    return this.http.get(`metrics/metric-value/okr_metrics`);
  }

  getGoalOpp(queryParam: any) {
    return this.http.get(`okr/opportunity-goals/?${queryParam}`);
  }

  getGoalProject(queryParam: any) {
    return this.http.get(`delivery/get-risk-goal-project/?${queryParam}`);
  }

  getGoalApplication(queryParam: any) {
    return this.http.get(`master/application/list-unique/?${queryParam}`);
  }

  updateOkr(payload: any) {
    return this.http.post(`okr/`, payload);
  }

  createMosValue(payload: any, id: any = "") {
    return this.http.post(`okr/measure_of_success/`, payload);
  }

  deleteMosValue(id: any) {
    return this.http.delete(`okr/measure_of_success/${id}`);
  }
  getUser() {
    return this.http.get(`users/user-list/`);
  }
  getBaseValue(type: any) {
    return this.http.get(`base_value/?type=${type}`);
  }

  getGoalChallenges(qParam: any) {
    return this.http.get(
      `challenge_workbench/challenge_statement/okr-challenges/?${qParam}`
    );
  }

  getOKRProgress(queryParams?: { [key: string]: any }) {
    return this.http.get(`okr/okr-progress/`, { params: queryParams });
  }

  uploadFile(keyResultId: number, file: File): Observable<any> {

    const formData = new FormData();
    formData.append('file', file);

    return this.http.post(`okr/${keyResultId}/upload-file/`, formData);
  }
  deleteFile(fileId: number) {
    return this.http.delete(`okr/delete-file?file_id=${fileId}`);
  }

  downloadFile(fileId: number) {
    return this.http.get(
      `okr/download-file?file_id=${fileId}`,
      { responseType: 'blob' }
    );
  }

  createObjective(objective: any) {
    return this.http.post(
      `okr/create-objective/`,
      objective
    );
  }
}
